import React from 'react';
import styled from '@emotion/styled';
import { Button, Colors } from '@zapier/design-system';
import { lightOrange } from 'constants/blogColors';
import { useInView } from 'react-intersection-observer';
import { useTrackEvent } from 'tracking/useTrackEvent';
import { mediaQueries } from 'components/mediaQueries';
import backgroundArtwork from './backgroundArtwork.png';
import { Link } from 'components/Link/Link';

export const ZapierProductModule = () => {
  const trackEvent = useTrackEvent();
  const [ref, inView] = useInView();

  React.useEffect(() => {
    if (inView) {
      trackEvent('component_scrolled_into_view', {
        component: 'Zapier Product Module',
      });
    }
  }, [ref, inView]);

  return (
    <Outer ref={ref}>
      <BackgroundArt>
        <ContentWrapper>
          <Text>
            Improve your productivity automatically. Use Zapier to get your apps
            working together.
          </Text>
          <CTAWrapper>
            <Button
              href="/sign-up"
              hasShadow={true}
              onClick={() =>
                trackEvent('call_to_action', {
                  path: window.location.pathname,
                  from_path: document.referrer,
                  cta_name: 'signup_pre_intent',
                  cta_raw_text: 'sign up',
                  cta_location: 'zapier product module',
                  cta_goal: 'signup',
                  signup_type: '',
                  link_destination: '/sign-up',
                })
              }
              isFullWidth={true}
              size="medium"
            >
              Sign up
            </Button>
            <SeeHowItWorksLink
              href="/how-it-works"
              onClick={(event) =>
                trackEvent('linkClicked', {
                  linkText: 'See how it works',
                  href: '/how-it-works',
                  path: window.location.pathname,
                  posYFromTop: event.clientY,
                })
              }
            >
              See how it works
            </SeeHowItWorksLink>
          </CTAWrapper>
        </ContentWrapper>
      </BackgroundArt>
    </Outer>
  );
};

const Outer = styled.section`
  display: flex;
  background-color: ${lightOrange};
  justify-content: center;
  text-align: center;
  width: 100%;
  ${mediaQueries.tablet} {
    text-align: left;
  }
`;

const BackgroundArt = styled.div`
  ${mediaQueries.tablet} {
    background-image: url(${backgroundArtwork});
    background-repeat: no-repeat;
    background-position: 411px;
    background-size: 473px;
    text-align: left;
    width: 966px;
  }

  ${mediaQueries.desktop} {
    background-position: 725px;
    background-size: 550px;
    width: 1280px;
  }
`;

const ContentWrapper = styled.div`
  padding: 50px 20px 60px 20px;

  ${mediaQueries.tablet} {
    max-width: 381px;
    padding-left: 40px;
  }

  ${mediaQueries.desktop} {
    max-width: 650px;
    padding: 127px 0 127px 60px;
  }
`;

const Text = styled.h2`
  color: ${Colors.grey900};
  font-weight: 800;
  font-size: 28px;
  line-height: 120%;
  margin-bottom: 40px;

  ${mediaQueries.tablet} {
    font-size: 40px;
  }
`;

const CTAWrapper = styled.div`
  display: grid;
  grid-gap: 30px;
  grid-template-columns: 175px;
  justify-content: center;
  justify-items: center;

  ${mediaQueries.tablet} {
    grid-gap: 25px;
    grid-template-columns: 175px max-content;
    justify-content: start;
  }
`;

const SeeHowItWorksLink = styled(Link)`
  color: ${Colors.grey900};
  font-weight: bold;
  font-size: 19px;
  line-height: 140%;
  text-decoration: underline;

  ${mediaQueries.tablet} {
    align-self: center;
  }
`;
